import {MessageDescriptor} from './message-descriptor';

interface MessageProps extends Omit<MessageDescriptor, 'message'> {}
export default function message(msg: string, props?: MessageProps): MessageDescriptor {
  return {...props, message: msg};
}
